import styled from 'styled-components';
import { ListGroup } from 'reactstrap';

export default styled(ListGroup)``;
